import MainContainer from './components/MainContainer';
import './App.css';

function App() {
  return (
    <div className="bg-color-white">
      <MainContainer/>
    </div>
  );
}

export default App;
